import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgArrowSmallForward = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 24,
	height: 24,
	fill: "none",
	viewBox: "0 0 24 24",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		fill: "#111",
		fillRule: "evenodd",
		d: "M8 16.973 12.945 12 8 7.027 9.522 5.5 16 12l-6.478 6.5L8 16.973z",
		clipRule: "evenodd"
	})
});
export default SvgArrowSmallForward;
